import {FETCH_RATE_CARD_VALUE, FETCH_RATE_CARD_VALUE_SUCCESS, FETCH_RATE_CARD_VALUE_ERROR, UPDATE_RATE_CARD_VALUE, UPDATE_RATE_CARD_VALUE_SUCCESS, UPDATE_RATE_CARD_VALUE_ERROR, RESET_UPDATE_RATE_CARD_VALUE} from 'constants/ActionTypes'

const INIT_STATE = {
  error: '',
  loading: false,
  updating: false,
  data: [],
  payload: {},
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_RATE_CARD_VALUE: {
      return {...state, error: '', loading: true};
    }
    case UPDATE_RATE_CARD_VALUE: {
      return {...state, error: '', updating: true};
    }
    case FETCH_RATE_CARD_VALUE_SUCCESS: {
      return {...state, error: '', data: action.payload, loading: false};
    }
    case UPDATE_RATE_CARD_VALUE_SUCCESS: {
      return {...state, error: '', payload: { code: 200, message: 'Cập nhật dữ liệu thành công!' }, updating: false};
    }
    case FETCH_RATE_CARD_VALUE_ERROR: {
      return {...state, loading: false, error: action.payload};
    }
    case UPDATE_RATE_CARD_VALUE_ERROR: {
      return {...state, updating: false, error: action.payload, payload: { code: 500, message: 'Có lỗi trong quá trình xử lý!' }};
    }
    case RESET_UPDATE_RATE_CARD_VALUE: {
      return {...state, payload: {}};
    }
    default:
      return state;
  }
}
